import { connect } from 'react-redux';
import { IActivityProps } from '../../../../boardDetails/activity/TabActivity/types';
import { IRestCardCommonActivity } from '../../../../../../../types/rest/activity/IRestCardCommonActivity';
import { IApplicationState } from '../../../../../../../types/types';
import { CardActivityCopy } from '../../components/CardActivityCopy/CardActivityCopy';
import { ICardActivityCopyEvents, ICardActivityCopyFields } from '../../components/CardActivityCopy/types';
import { onLinkClick } from './events/onLinkClick';

const mapStateToProps = (
    state: IApplicationState,
    { activity }: IActivityProps<IRestCardCommonActivity>
): ICardActivityCopyFields => {
    return {
        activity
    }
};

const mapDispatchToProps = (
    dispatch: any
): ICardActivityCopyEvents => {
    return {
        onLinkClick: (cardId) => dispatch(onLinkClick(cardId)),
    };
};

export const CardActivityCopyHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(CardActivityCopy);

CardActivityCopyHOC.displayName = 'CardActivityCopyHOC';
